import { render } from "./FooterSection.vue?vue&type=template&id=1d7522a1&scoped=true"
const script = {}

import "./FooterSection.vue?vue&type=style&index=0&id=1d7522a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7522a1"]])

export default __exports__